module.exports = __webpack_public_path__ + "static/media/going2.c63bc222.webp";